import styled from "styled-components";

export const H1 = styled.h1`
    font-family: "GTAmerica", sans-serif;
    font-weight: 700;
    font-size: 52px;
    line-height: 56px;
    text-align: center;
`;

export const H2 = styled.h2`
    font-family: "GTAmerica", sans-serif;
    font-weight: 700;
    font-size: 40px;
    line-height: 48px;
`;

export const H3 = styled.h3`
    font-family: "GTAmerica", sans-serif;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
`;

export const Text18 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
`;

export const Text14W500 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    @media (max-width: 768px) {
        font-weight: 500;
        font-size: 12px;
        leading-trim: NONE;
        line-height: 16px;
        letter-spacing: 0%;
        vertical-align: middle;
    }
`;

export const Text14_400 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
`;


export const Text16W400 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 400;
    font-style: Regular;
    font-size: 12px;
    leading-trim: NONE;
    line-height: 16px;
    letter-spacing: 4%;
    vertical-align: middle;
    text-transform: uppercase;
`;


export const Text52W700 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 700;
    font-size: 52px;
    leading-trim: NONE;
    line-height: 56px;
    letter-spacing: 0%;
    text-align: center;
    @media (max-width: 768px) {
        font-weight: 700;
        font-size: 32px;
        leading-trim: NONE;
        line-height: 38px;
        letter-spacing: 0%;
    }
`;


export const Text18W400 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 400;
    font-style: Regular;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 0%;
    text-align: center;
`;

export const Text18W500 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 500;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    @media (max-width: 768px) {
        font-weight: 500;
        font-style: Medium;
        font-size: 16px;
        leading-trim: NONE;
        line-height: 20px;
        letter-spacing: 0%;
        vertical-align: middle;
    }
`;


export const Text40_700 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 700;
    font-size: 40px;
    leading-trim: NONE;
    line-height: 48px;
    letter-spacing: 0%;
    text-align: center;
`;


export const Text24W700 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 700;
    font-style: Bold;
    font-size: 24px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: 0%;
    vertical-align: bottom;


`;

export const SText12W400 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #acacad;
    text-align: center;
`;

/* Мелкий серый текст */
export const SText14W400 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #acacad;
    text-align: center;
`;

/* Текст под названием фирмы, показатели */
export const SFText18W400 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #1d2023;
    @media (max-width: 768px) {
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
        leading-trim: NONE;
        line-height: 20px;
        letter-spacing: 0%;
    }
`;

export const SFText18W400Div = styled.div`
    font-family: "GTAmerica", sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #1d2023;
    @media (max-width: 768px) {
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
        leading-trim: NONE;
        line-height: 20px;
        letter-spacing: 0%;
    }
`;

export const Text24W500 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 500;
    font-style: Medium;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    color: #212A34;
`

/* Числовые показатели */
export const SText24W700 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    color: #1d2023;
    @media (max-width: 768px) {
        font-weight: 700;
        font-style: Bold;
        font-size: 20px;
        leading-trim: NONE;
        line-height: 24px;
        letter-spacing: 0%;
        vertical-align: bottom;
    }
`;

/* Название фирмы */
export const SText40W700 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 700;
    font-size: 40px;
    line-height: 48px;
    color: #1d2023;

    @media (max-width: 768px) {
        font-weight: 700;
        font-size: 32px;
        leading-trim: NONE;
        line-height: 36px;
        letter-spacing: 0%;
    }
`;

/* Подзаголовок под названием фирмы */
export const S_Text18_W400 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #24303b;
    @media (max-width: 768px) {
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
        leading-trim: NONE;
        line-height: 20px;
        letter-spacing: 0%;
    }
`;


export const SText16W700 = styled.p`
    font-family: "GTAmerica", sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 18.67px;
    color: #1D2023;
    text-align: center;
`;